<template>
	<div class="countdownComponent">
		<div
				class="number d-flex align-items-center justify-content-center"
				:class="{last: n === 0}"
				v-for="n in pastNumbersArray"
				:key="n"
		>
			{{n}}
		</div>
	</div>
</template>

<script>

  export default {
    data() {
      return {
        secondsLeft: 0,
        show: false,
      };
    },
    props: {
      seconds: {type: Number, required: true},
    },
    computed: {
      gracePeriod() {
        return 500;
      },
      pastNumbersArray() {
        const numbers = [];
        for (let n = this.seconds; n >= this.secondsLeft; --n) {
          numbers.push(n);
        }
        return numbers;
      },
    },
    created() {
      const totalTime = this.seconds * 1000;
      this.secondsLeft = this.seconds;

      this.gracePeriodStartTimer = setTimeout(() => {
        this.$emit('gracePeriodStart');
      }, totalTime - this.gracePeriod / 2);

      this.gracePeriodEndTimer = setTimeout(() => {
        this.$emit('gracePeriodEnd');
      }, totalTime + this.gracePeriod / 2);

      this.countdownTimer = setInterval(() => {
        --this.secondsLeft;
        if (this.secondsLeft === 0) {
          clearInterval(this.countdownTimer);
          this.$emit('countdownEnd');
        }
        this.show = !this.show;
        setTimeout(() => this.show = !this.show, 0)
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.countdownTimer);
      clearTimeout(this.gracePeriodStartTimer);
      clearTimeout(this.gracePeriodEndTimer);
    }
  };

</script>

<style>
	.countdownComponent {
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.countdownComponent .number {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		animation: countdownNumberAnimation 1300ms ease-in;
		opacity: 0;
	}

	.countdownComponent .number.last {
		animation: none;
		opacity: 1;
	}

	@keyframes countdownNumberAnimation {
		0% {
			opacity: 1;
			transform: scale(1);
		}
		100% {
			opacity: 0;
			transform: scale(.2);
		}
	}
</style>
